/*
 * @Author: Vanny
 * @Date: 2020-05-07 17:42:06
 * @LastEditors: Vanny
 * @LastEditTime: 2020-05-09 09:46:37
 * @Description: 登录接口
 */
import axios from 'axios';
import invariant from 'invariant';
import { isMC } from 'src/utils/env';

/**
 * 获取随机数
 */
export function requestUserRandom() {
  return axios.post('/user/get_random');
}
/**
 * 获取token
 * @param {*} params
 */
export function requestAirToken(params) {
  invariant(params?.code, '缺少随机数 code'); // 2022年9月更新扫码，修改参数从random变为code
  return axios.get('/user/get_web_token', { params });
}
/**
 * 获取创建二维码的时间戳
 * 只是拿时间戳就不分正式和测试环境
 */
export function requestCreateTime(){
  return axios.get(isMC() ? 'https://api2.dokkr.net/time.php' : 'https://api.duoke.net/time.php');
}
